import { Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { LegendBoxList, LegendCssIcoListItem } from "../../legend/LegendBoxComponents";
import { memo } from "react";

function LegendAmeyuki() {
  const {t} = useTranslation();
  return (
    <>
      <Box sx={{minWidth: 130}}>
        <LegendBoxList>
          <LegendCssIcoListItem background={"rgb(202, 49, 49)"} text={t("wet strong snow")}></LegendCssIcoListItem>
          <LegendCssIcoListItem background={"rgb(253, 202, 202)"} text={t("wet weak snow")}></LegendCssIcoListItem>
          <LegendCssIcoListItem background={"rgb(0 ,151, 0)"} text={t("dry strong snow")}></LegendCssIcoListItem>
          <LegendCssIcoListItem background={"rgb(202, 253, 202)"} text={t("dry weak snow")}></LegendCssIcoListItem>
          <LegendCssIcoListItem background={"rgb(153, 51, 204)"} text={t("sleet")}></LegendCssIcoListItem>
          <LegendCssIcoListItem background={"rgb(0, 0, 255)"} text={t("strong rain")}></LegendCssIcoListItem>
          <LegendCssIcoListItem background={"rgb(0, 255, 255)"} text={t("weak rain")}></LegendCssIcoListItem>
        </LegendBoxList>
      </Box>
    </>
  )
}

export default memo(LegendAmeyuki);